import { APIHandler } from "../base";

export interface QuestionUsage {
    enabled: boolean;
    limit: number | null;
    used: number;
}

export const fetchQuestionUsage = () => APIHandler.get("/licensing/usage");
